import {
  attachCustomsInfoSelector,
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES,
  LABEL_PROPERTY_ATTACH_CUSTOMS_INFO,
  updateLabelConfig,
} from '../../../data/labelInfos/index.js'
import ConfigSelect from './ConfigSelect.js'
import {UPS, USPS_SHIP} from '../../../common/constants/ShipperNames.js'
import {getState, useSelector} from '../../../store.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'

const VALID_SHIPPER_TYPES = [UPS, USPS_SHIP]

const RECEIVER_TYPE_DEPENDENT_PROPERTIES = [
  ...ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES,
  LABEL_PROPERTY_ATTACH_CUSTOMS_INFO,
]

function dependentPropertiesFunc() {
  return RECEIVER_TYPE_DEPENDENT_PROPERTIES
}

export function formatReceiverTypeLabelProperty(shipperType) {
  return `${shipperType}__receiver_type`
}

export function receiverTypeLabelPropertiesFunc(shipperType, labelInfoID) {
  const attachCustomsInfo = attachCustomsInfoSelector(getState(), {labelInfoID})

  return attachCustomsInfo ? [formatReceiverTypeLabelProperty(shipperType)] : []
}

const VALID_RECEIVER_TYPE_LABEL_PROPERTIES = VALID_SHIPPER_TYPES.map(
  (shipperType) => formatReceiverTypeLabelProperty(shipperType),
)

export default function ReceiverType() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const [propertySpecs] = ReceiverType.propertySpecList
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const attachCustomsInfo = useSelector((state) =>
    attachCustomsInfoSelector(state, {labelInfoID}),
  )

  return (
    <ConfigSelect
      label="Receiver Type"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: value,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      shipperOptionsProperty="entity_type"
      hide={!attachCustomsInfo}
    />
  )
}

ReceiverType.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc: receiverTypeLabelPropertiesFunc,
    dependentPropertiesFunc,
    validLabelPropertiesFunc() {
      return VALID_RECEIVER_TYPE_LABEL_PROPERTIES
    },
  },
]
